export const socketState = {
    namespaces: {},
};
